exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".second[data-v-1bbcc0a7] {\n  margin-left: 70px;\n}\n.error[data-v-1bbcc0a7] {\n  display: block;\n  margin-top: 5px;\n  color: #d23131;\n}\n.noUpdate[data-v-1bbcc0a7] {\n  background-color: transparent;\n  border: none;\n}\n.content-tlist[data-v-1bbcc0a7] {\n  border: none;\n}", ""]);

// exports
